import { render, staticRenderFns } from "./BaseDetails.vue?vue&type=template&id=37c95a54&"
import script from "./BaseDetails.vue?vue&type=script&lang=js&"
export * from "./BaseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports